import { atom } from 'recoil'

export const workState = atom({
    key: 'workAtom',
    default: null,
})